export default function Error() {
  return (
    <>
      <h1>Error page</h1>
    </>
  )
}
